import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "variants-matrix-cell"
};
import { computed } from 'vue';
import ArticleQuantityInput from "@astina/paloma-shop-common-ui/src/components/ArticleQuantityInput.vue";
import productUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductArticlesMatrixCell',
    props: {
        variant: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const quantityConfig = computed(() => {
            if (!props.variant) {
                return { initial: 0, decimals: 0 };
            }
            const config = productUtils.createQuantityConfig(0, props.variant);
            config.min = 0; // TODO remove after PALO-3334 is resolved
            return config;
        });
        function onQuantityChange(quantity) {
            const itemDraft = {
                sku: props.variant.sku,
                quantity: quantity.quantity,
                portions: quantity.portions,
                // allowedUnavailabilityReasons: TODO
            };
            emit('change', itemDraft);
        }
        return (_ctx, _cache) => {
            return (__props.variant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(ArticleQuantityInput, {
                        config: quantityConfig.value,
                        available: true,
                        "reset-on-cart-item-added": true,
                        "reset-portions-on-close": true,
                        onChange: onQuantityChange
                    }, null, 8, ["config"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
